<info_logs_base_area>

    <section>
        <div style="background-color: white;margin-bottom:6em">

            <div
                    class="com-profile-mainblock"
                    style="
      --body-color: #FFFFFF;
      --body-text-color: #000000;
      --link-text-color: #000000;
    "
            >
                <section class="com-works__item">

                    <h3 class="com-works__item__ttl">
                        お知らせ
                    </h3>

                    <info_log_area
                            each={(info_log,index) in state.info_logs}
                            info_log={info_log}
                            index={index}
                            last_item={(index+1 == state.info_logs.length) ? "yes" : "no"}
                    >
                    </info_log_area>

                </section>

            </div>

        </div>
    </section>


    <style>

        .com-works__item div.com-works__item__inner[last_item='no']
        {
            border-bottom: 1.5px solid gray;
            padding-bottom: 2rem;
        }

        .com-works__item div.com-works__item__inner{
            margin-top: 20px
        }

        .com-works__item div.com-works__item__inner dt{
            font-size: 2rem;
            font-weight: bold;
            margin-bottom: 0.5rem;
        }

        @media screen and (max-width: 811px){
            .infomation_thumb_block{
                text-align: center;
                margin-bottom:1rem;
            }
            .infomation_thumb_block img{
                display: inline-block;
            }
        }
        @media screen and (min-width: 812px){
            .infomation_thumb_block{
                float: left;
                margin-right: 1.5rem;
            }
        }
    </style>

    <script>

        import di from 'dependeny-injection'
        import common_article_non_escape_html from './../../../../common/tags/page_object/common_page_object_non_escape_html.riot'
        //import dayjs from 'dayjs'
        import info_log_area from './info_log_area.riot'

        export default{
            components:{
                common_article_non_escape_html:common_article_non_escape_html,
                info_log_area :info_log_area,
            },
            state:{
                info_logs : [],
            },
            onMounted(){

                let my = this;
                di.info_log.get().then(function (data) {
                    my.state.info_logs = data.info_logs;
                    my.update();
                });
            },
            formatDate(log_time){
                return dayjs(log_time * 1000).format("YYYY-MM-DD");
            },

        }

    </script>
</info_logs_base_area>